require('./RAPortfolioDonut.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const Immutable = require('immutable');

// @commons
const RAPieChart = require('../commons/RAPieChart/RAPieChart');

// @utilities
const {
    formatPercentageWithDecimals,
} = require('../../utilities/RACurrencyHelper');
const RAAssetsHelper = require('../../utilities/RAAssetsHelper');

// @constants
const { PERCENTAGE_SYMBOL } = require('constants/index');
const {
    ACTIVE_CLASS_MONEY_MARKET_ID,
    ACTIVE_CLASS_FIXED_INCOME_ID,
    ACTIVE_CLASS_EQUITY_ID,
    ACTIVE_CLASS_REAL_ASSETS_ID,
} = require('../../raConstants/index');

class RAPortfolioDonut extends React.Component {
    getBarClassName(assetClassId) {
        const customClass = classNames('ra-portfolio-donut__bar', {
            ['ra-portfolio-donut__bar--money-market']:
                assetClassId === ACTIVE_CLASS_MONEY_MARKET_ID,
            ['ra-portfolio-donut__bar--fixed-income']:
                assetClassId === ACTIVE_CLASS_FIXED_INCOME_ID,
            ['ra-portfolio-donut__bar--equity']:
                assetClassId === ACTIVE_CLASS_EQUITY_ID,
            ['ra-portfolio-donut__bar--real-assets']:
                assetClassId === ACTIVE_CLASS_REAL_ASSETS_ID,
        });

        return customClass;
    }

    buildDonutChart(immAssetAllocations) {
        const assetData = immAssetAllocations.map(asset => ({
            key: asset.get('assetClassId'),
            label: asset.get('assetClass'),
            value: asset.get('weight'),
        }));

        return (
            <div className="ra-portfolio-donut__item">
                <RAPieChart data={assetData} />
            </div>
        );
    }

    buildDistributionSubAssetsItems(subAssets) {
        const subAssetItemBlock = subAssets.map(subAsset => (
            <div
                key={subAsset.get('subAssetClassId')}
                className="ra-portfolio-donut__sub-item"
            >
                <span className="ra-portfolio-donut__sub-item-label">
                    {subAsset.get('subAssetClass')}
                </span>
                <span className="ra-portfolio-donut__sub-item-value">
                    {formatPercentageWithDecimals(
                        subAsset.get('weight'),
                        false,
                    )}
                </span>
                <span className="ra-portfolio-donut__sub-item-symbol-label">
                    {PERCENTAGE_SYMBOL}
                </span>
            </div>
        ));

        return subAssetItemBlock;
    }

    buildDistributionAssetsTabs(immAssetAllocations) {
        const baseAssets = RAAssetsHelper.getEmptyStateAssets();
        const immAssetAllocated = baseAssets.map(asset => {
            const immAssets = immAssetAllocations.find(
                immAsset => immAsset.get('assetClassId') === asset.assetClassId,
            );
            const assetAllocated = immAssets
                ? immAssets
                : Immutable.fromJS(asset);

            return assetAllocated;
        });

        const assetsTabsBlock = immAssetAllocated.map(assetAllocation => {
            const assetClassId = assetAllocation.get('assetClassId');
            const barClassName = this.getBarClassName(assetClassId);
            const subAssetClasses = assetAllocation.get(
                'subAssetClasses',
                assetAllocation.get('subAssetAllocations'),
            );
            const subAssetsItemsBlock = subAssetClasses
                ? this.buildDistributionSubAssetsItems(subAssetClasses)
                : null;
            const percentage = formatPercentageWithDecimals(
                assetAllocation.get('weight'),
                false,
            );

            return (
                <div
                    key={assetClassId}
                    className="ra-portfolio-donut__tab-item"
                >
                    <div className="ra-portfolio-donut__item-container">
                        <div className="ra-portfolio-donut__item-title-label">
                            {assetAllocation.get('assetClass')}
                        </div>
                        <div className="ra-portfolio-donut__item-container-percent">
                            <span className="ra-portfolio-donut__item-percent-label">
                                {percentage}
                            </span>
                            <span className="ra-portfolio-donut__item-symbol-label">
                                {PERCENTAGE_SYMBOL}
                            </span>
                        </div>
                        <div className="ra-portfolio-donut__sub-items">
                            <div className="dropdown-sub-items">
                                {subAssetsItemsBlock}
                            </div>
                        </div>
                        <div className={barClassName} />
                    </div>
                </div>
            );
        });

        return assetsTabsBlock;
    }

    render() {
        const { immAssetAllocations } = this.props;
        const donutChartBlock = this.buildDonutChart(immAssetAllocations);
        const distributionAssetsTabsBlock = this.buildDistributionAssetsTabs(
            immAssetAllocations,
        );

        return (
            <div className="ra-portfolio-donut">
                <div className="ra-portfolio-donut__tabs">
                    {donutChartBlock}
                    {distributionAssetsTabsBlock}
                </div>
            </div>
        );
    }
}

RAPortfolioDonut.propTypes = {
    immAssetAllocations: PropTypes.object.isRequired,
};

module.exports = RAPortfolioDonut;
